/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, bool, func } from "prop-types";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import moment from "moment";
import CustomData from "pages/_components/CustomData/CustomData";
import * as i18n from "util/i18n";
import Avatar from "pages/_components/Avatar";
import Button from "pages/_components/Button";
import CustomText from "pages/_components/CustomText/CustomText";
import { transactionStatus } from "pages/transactions/constants";
import FormattedDate from "pages/_components/FormattedDate";
import GridTable from "pages/_components/GridTable/GridTable";

const EmitDebinSummaryBody = (props) => {
    const { showMoreData, setShowMoreData } = props;
    const { transaction = {} } = useContext(TransactionContext);
    const {
        data = {},
        creationDateTime = moment(),
        idTransaction = "",
        idTransactionStatus = "",
        userCreatorLastName = "",
        userCreatorFirstName = "",
        signatures = [],
    } = transaction;
    const {
        beneficiary = props.beneficiary,
        beneficiaryName = props.beneficiaryName,
        accountInfo = props.accountInfo,
        service = props.service,
        reference = props.reference,
        concept = props.concept,
        description = props.description,
    } = data;
    const accountSubstring = accountInfo.substring(1);

    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const isFinished = idTransactionStatus === transactionStatus.FINISHED;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    return (
        <div className={`ticket__body ${idTransaction ? "echeq-masive-emit" : "echeq-emit"}`}>
            {idTransaction && (
                <>
                    <div className="view-more-data-button" id="element-to-ignore">
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                    <div className={`view-more-data ${showMoreData ? "expand" : "collapse"}`}>
                        <h2>{i18n.get("creditBill.aditionalData.label")}</h2>

                        <CustomData
                            titleText="afip.debit.account.title"
                            titleTextType="I18N"
                            valueText={`****${accountSubstring}`}
                            valueTextType={`****${accountSubstring}`}
                        />
                        {/* {isFinished && (
                            <>
                                <CustomData
                                    titleText="ticket.voucher"
                                    titleTextType="I18N"
                                    valueText={idTransaction.substring(0, 8)?.toUpperCase()}
                                    valueTextType="TEXT"
                                />
                                <div className="custom-data">
                                    <div className="custom-text custom-data-title ">
                                        {i18n.get("transfer.dateHourtime")}
                                    </div>
                                    <span className="custom-text custom-data-value data-label">
                                        <FormattedDate date={creationDateTime} dateFormat="DD/MM/YYYY HH:mm:ss" />
                                    </span>
                                </div>
                            </>
                        )} */}
                        <CustomData
                            titleText="debin.service.label"
                            titleTextType="I18N"
                            valueText={service}
                            valueTextType="TEXT"
                        />
                        <CustomData
                            titleText="debin.reference"
                            titleTextType="I18N"
                            valueText={reference}
                            valueTextType="TEXT"
                        />
                        <CustomData
                            titleText="debin.concept.label"
                            titleTextType="I18N"
                            valueText={concept}
                            valueTextType="TEXT"
                        />
                        <CustomData
                            titleText="debin.description.label"
                            titleTextType="I18N"
                            valueText={description}
                            valueTextType="TEXT"
                        />
                        {/* <CustomData
                            titleText="echecks.createdRange.label"
                            titleTextType="I18N"
                            valueText={creationDateTime}
                            valueTextType="DATE"
                        />
                        <CustomData
                            titleText="ticket.voucher"
                            titleTextType="I18N"
                            valueText={idTransaction.substring(0, 8).toUpperCase()}
                            valueTextType="TEXT"
                        /> */}
                        <div className="signatures-data">
                            <div className="ticket__divider signatures-divider inside-ticket__body">
                                <div className="ticket__notch ticket__notch--left"> </div>
                                <div className="ticket__notch ticket__notch--right"> </div>
                            </div>
                            <h2>{i18n.get("forms.transaction.ticket.title")}</h2>
                            <div className="createdby-signature">
                                <CustomData
                                    titleText="forms.transaction.ticket.createdBy"
                                    titleTextType="I18N"
                                    valueText={`${userCreatorLastName}, ${userCreatorFirstName}`}
                                />
                                <div className="tiny-small font-bold secondary">
                                    <FormattedDate
                                        className="small"
                                        date={creationDateTime}
                                        dateFormat="DD/MM/YYYY HH:mm:ss"
                                    />
                                </div>
                            </div>
                            <div className="approval-signature custom-data">
                                <div className="custom-text custom-data-title ">
                                    {i18n.get("forms.transaction.ticket.signedBy")}
                                </div>
                                {signatures?.map((signature, index) => (
                                    <span className="custom-text custom-data-value data-label">
                                        {`${signature.userFullName} (${signature.signatureLevel})${
                                            index !== signatures?.length - 1 ? "," : ""
                                        }`}
                                        <div className="tiny-small font-bold secondary">
                                            <FormattedDate
                                                date={signature.creationDateTime}
                                                dateFormat="DD/MM/YYYY HH:mm:ss"
                                            />
                                        </div>
                                    </span>
                                ))}
                            </div>
                            {isFinished && (
                                <div className="pending-signature">
                                    <div className="horizontal-divider" />
                                    <div className="pending-approval">
                                        <div className="tiny-small secondary">{i18n.get("transfer.dateHourtime")}</div>
                                        <div className="tiny-small font-bold secondary">
                                            <FormattedDate
                                                className="small"
                                                date={creationDateTime}
                                                dateFormat="DD/MM/YYYY HH:mm:ss"
                                            />
                                        </div>
                                    </div>
                                    <div className="vaucher">
                                        <CustomData
                                            titleText="ticket.voucher"
                                            titleTextType="I18N"
                                            valueText={idTransaction.substring(0, 8)?.toUpperCase()}
                                            valueClass="secondary"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
            {!idTransaction && (
                <GridTable>
                    <GridTable.Container columns="4">
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <CustomData
                                titleText="debin.debit.account"
                                titleTextType="I18N"
                                valueText={`****${accountSubstring}`}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={1}>
                            <CustomData
                                titleText="debin.service.label"
                                titleTextType="I18N"
                                valueText={service}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={3} rowStart={1}>
                            <CustomData
                                titleText="debin.reference"
                                titleTextType="I18N"
                                valueText={reference}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={1} rowStart={2}>
                            <CustomData
                                titleText="debin.concept.label"
                                titleTextType="I18N"
                                valueText={concept}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={2}>
                            <CustomData
                                titleText="debin.description.label"
                                titleTextType="I18N"
                                valueText={description}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            )}
        </div>
    );
};

EmitDebinSummaryBody.propTypes = {
    beneficiary: string,
    beneficiaryName: string,
    description: string,
    concept: string,
    reference: string,
    service: string,
    accountInfo: string,
    showMoreData: bool,
    setShowMoreData: func,
};

EmitDebinSummaryBody.defaultProps = {
    beneficiary: "",
    beneficiaryName: "",
    description: "",
    concept: "",
    reference: "-",
    service: "",
    accountInfo: "",
    showMoreData: false,
    setShowMoreData: () => {},
};

export default EmitDebinSummaryBody;
